// NOTICE: KAPTION-INTEGRATION
// Composable for managing Kaption utility templates
import { ref } from 'vue';
import KaptionUtilityTemplatesAPI from 'dashboard/api/kaptionUtilityTemplates';

export function useKaptionUtilityTemplates() {
  const templates = ref({});
  const isFetching = ref(false);

  const fetchTemplates = async (inboxId, type = null) => {
    if (!inboxId) return;
    isFetching.value = true;
    try {
      const response = await KaptionUtilityTemplatesAPI.getTemplates(
        inboxId,
        type
      );
      // API returns { templates: { followup: { en: [...], es: [...] }, ... } }
      templates.value = response.data?.templates || {};
    } catch (error) {
      // Silent failure
    } finally {
      isFetching.value = false;
    }
  };

  /**
   * Interpolate template body with variables
   * @param {string} body - Template body with {{1}}, {{2}} placeholders
   * @param {Object} variables - Variables object like { "1": "value1", "2": "value2" }
   * @returns {string} Interpolated string
   */
  const interpolateTemplate = (body, variables) => {
    if (!body) return '';
    if (!variables || Object.keys(variables).length === 0) return body;

    let interpolated = body;
    Object.entries(variables).forEach(([key, value]) => {
      const placeholder = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
      interpolated = interpolated.replace(placeholder, value);
    });
    return interpolated;
  };

  /**
   * Get template body by name across all types and languages
   * @param {string} templateName - The unique template name
   * @returns {string|null} The template body or null if not found
   */
  const getTemplateBody = templateName => {
    if (!templateName) return null;

    let foundBody = null;
    // Iterate through types (followup, scheduled, reminder)
    Object.values(templates.value).forEach(type => {
      if (foundBody) return;
      // Iterate through languages (en, es, pt, etc)
      Object.values(type).forEach(langTemplates => {
        if (foundBody) return;
        const template = langTemplates.find(t => t.name === templateName);
        if (template) foundBody = template.body;
      });
    });

    return foundBody;
  };

  return {
    templates,
    isFetching,
    fetchTemplates,
    interpolateTemplate,
    getTemplateBody,
  };
}
